import PmsUrlConfig from '../../urlConfig';
import Axios from 'axios';
import { setAuthToken } from '../common';
import { getRoomInitialSync } from '../matrix/matrixFuntions';

// Local storage keys for appointments caching
const APPOINTMENTS_STORAGE_KEY = 'patientAppointments';
const APPOINTMENTS_TIMESTAMP_KEY = 'patientAppointmentsTimestamp';

// Shared utility function for status color coding
export const getStatusColor = (status) => {
    switch (status) {
        case 'NEW':
            return 'bg-blue-100 text-blue-700';
        case 'SUSPENDED':
            return 'bg-yellow-100 text-yellow-700';
        case 'ACTIVE':
            return 'bg-green-100 text-green-700';
        case 'CLOSED':
        case 'DELETED':
        case 'DECLINED':
            return 'bg-red-100 text-red-700';
        default:
            return 'bg-gray-100 text-gray-700';
    }
};

const saveAppointmentsToStorage = (appointmentsData) => {
    try {
        localStorage.setItem(APPOINTMENTS_STORAGE_KEY, JSON.stringify(appointmentsData));
        localStorage.setItem(APPOINTMENTS_TIMESTAMP_KEY, Date.now().toString());
    } catch (error) {
        console.error('Error saving appointments to storage:', error);
    }
};


function formatDate(d){
    function pad(n){return n<10 ? '0'+n : n}
    return [d.getUTCFullYear(),'-',
           pad(d.getUTCMonth()+1),'-',
           pad(d.getUTCDate()),'T',
           pad(d.getUTCHours()),':',
           pad(d.getUTCMinutes()),':',
           pad(d.getUTCSeconds()),'+00:00'].join("");
   }

function formatDateForUI(dateString){
    var dateFns = require("date-fns")
    try {
        const parsed = dateFns.parse(dateString, "yyyy-MM-dd'T'HH:mm:ssXXX", new Date());
        const returnDate = dateFns.format(parsed, 'MM/dd/YYY HH:mm');
        
        return returnDate
    } catch (error) {
        console.log(dateString)
        console.log(error)
        return "";
    }
   
}

function formatDateForRoomName(dateString){
    var dateFns = require("date-fns")
    try {
        const parsed = dateFns.parse(dateString, "yyyy-MM-dd'T'HH:mm:ssXXX", new Date());
        const returnDate = dateFns.format(parsed, "MM/dd/YYY'T'HH:mm");
        
        return returnDate
    } catch (error) {
        console.log(error)
        return "";
    }
   
}

function formatDateForMessages(dateString){
    
    try {
        const parsed = new Date( Date.parse(dateString, "yyyy-MM-dd'T'HH:mm:ssXXX"));

        return parsed.toLocaleDateString("en-US") +" " +parsed.toLocaleTimeString()
    } catch (error) {
        console.log(error)
        return "";
    }
   
}
const handlePatientPinAppointment = async(appt, pinned, dispatch, unpinnedAppointments, pinnedAppointments) => {
    var selectedApptId = appt.appointment_basic_details._id;
    pinned = togglePinned(pinned);
   var pinAppointmentUrl = PmsUrlConfig.BOS_PATIENT_PIN_APPOINTMENT_URL + selectedApptId
    Axios.post(pinAppointmentUrl ,
        {
            appointment_basic_details:{
                _id : selectedApptId,
                patient_pinned : pinned,
            },
            last_updated_date_time: formatDate(new Date()),
        }
        ).then((response) => {
            if (response.status === 200) {
                appt.appointment_basic_details.patient_pinned = pinned
                dispatch({
                    type: 'selectAppointment',
                    payload: appt
                })
               
                updatePinning(pinned, appt.appointment_basic_details, pinnedAppointments, unpinnedAppointments, dispatch)
            }
            else if (response.status === 400 ) {
                console.log(response.data.error_code.description)
                // dispatch({
                //     type: 'practiceUpdateError',
                //     payload: response.data.error_code.description
                // })
            }
        }).catch((error) => {
            console.log("error-------->",error)
            
            // dispatch({
            //     type: 'practiceUpdateError',
            //     payload: error.response.data.error_code.description
            // })
        })
};

const updatePinning = (pin, selectedAppt, pinnedAppts, unPinnedAppts, dispatch) => {
    var newPinnedAppointments = [];
    var newUnPinnedAppointments = [];
    if (pin) {
        newUnPinnedAppointments = unPinnedAppts.filter(item => item._id !== selectedAppt._id);
        pinnedAppts.push(selectedAppt);
        newPinnedAppointments = pinnedAppts;
        
    }
    else {
        newPinnedAppointments = pinnedAppts.filter(item => item._id !== selectedAppt._id)
        unPinnedAppts.push(selectedAppt);
        newUnPinnedAppointments = unPinnedAppts;
       
    }
    dispatch({
        type: 'setPinnedAppointments',
        payload: newPinnedAppointments
    })
    dispatch({
        type: 'setUnPinnedAppointments',
        payload: newUnPinnedAppointments
    })

}

const handleArchiveAppointmentForPatient = async(appt, loggedInUser, pinnedAppointments, unpinnedAppointments, dispatch) => {
    var selectedApptId = appt.appointment_basic_details._id;
    console.log("ARCHIVE:",selectedApptId)
    var archiveAppointmentUrl = PmsUrlConfig.BOS_PATIENT_ARCHIVE_APPOINTMENT_URL + selectedApptId
    Axios.post(archiveAppointmentUrl ,
        {
            _id : selectedApptId,
            archive_msg : true,
            last_updated_by: loggedInUser._id,
            last_updated_date_time: formatDate(new Date()),
        }
        ).then((response) => {
            if (response.status === 200) {
                appt.pinned = false
                dispatch({
                    type: 'selectAppointment',
                    payload: null
                })
                removeApptFromList(appt, pinnedAppointments, unpinnedAppointments, dispatch)
            }
            else if (response.status === 400 ) {
                console.log(response.data.error_code.description)
            }
        }).catch((error) => {
            console.log("error-------->",error)
            console.log(error.response.data.error_code.description)
        })
};

const removeApptFromList = (selectedAppt, pinnedAppts, unPinnedAppts, dispatch) => {
    var newPinnedAppointments = [];
    var newUnPinnedAppointments = [];
   
    if (selectedAppt) {
        newUnPinnedAppointments = unPinnedAppts.filter(item => item.appointment_basic_details._id !== selectedAppt.appointment_basic_details._id);
        newPinnedAppointments = pinnedAppts.filter(item => item.appointment_basic_details._id !== selectedAppt.appointment_basic_details._id)
    }
    dispatch({
        type: 'setPinnedAppointments',
        payload: newPinnedAppointments
    })
    dispatch({
        type: 'setUnPinnedAppointments',
        payload: newUnPinnedAppointments
    })
}

const getServiceTypeString = (sValue, serviceTypes) => {
    
    if (!serviceTypes || !Array.isArray(serviceTypes)) {
        return sValue;
    }
    
    var resultArr = serviceTypes.filter((item) => item.value === sValue);
    if(resultArr !== null && resultArr.length === 1){
        return resultArr[0].label;
    }
    return sValue
}

const togglePinned =(pinned)=>{
    if(pinned === false)
        pinned = true;
    else 
        pinned = false;
    return pinned
  };

const fetchUserAppointments = async (userId, pageNum, dispatch, token) => {
    console.log("Page Number:", pageNum);
    var fetchApptsForUser = PmsUrlConfig.BOS_FETCH_APPOINTMENTS_FOR_PATIENT_URL + userId + "/" + pageNum
    setAuthToken(token)
    Axios.get(fetchApptsForUser)
        .then(response => response.data)
        .then(apptResponse => {
            var currentPageNum = apptResponse.PageNum
            var appointmentsForUser = apptResponse.Appointments
            if(appointmentsForUser === null) {
                console.log("No appointments found");
                dispatch({
                    type: 'setPinnedAppointments',
                    payload: null
                });
                dispatch({
                    type: 'setUnPinnedAppointments',
                    payload: null
                });
                dispatch({
                    type: 'setCurrentPageNumber',
                    payload: parseInt(currentPageNum)
                });
                dispatch({
                    type: 'setAppointmentsForUser',
                    payload: null
                });
                return;
            }
            dispatch({
                type: 'setAppointmentsForUser',
                payload: appointmentsForUser
            });
            // Save appointments to localStorage for caching
            saveAppointmentsToStorage(appointmentsForUser);
            dispatch({
                type: 'setSortAscending',
                payload: false
            });
            dispatch({
                type: 'setCurrentPageNumber',
                payload: parseInt(currentPageNum)
            });
            if (appointmentsForUser != null ){
                
                var pinnedAppointments = appointmentsForUser.filter(item => item.patient_pinned);
                
                if(pinnedAppointments != null){
                    dispatch({
                        type: 'setPinnedAppointments',
                        payload: pinnedAppointments
                    });
                }
                var unpinnedAppointments = appointmentsForUser.filter(item => !item.patient_pinned);
                
                if(unpinnedAppointments != null){
                    dispatch({
                        type: 'setUnPinnedAppointments',
                        payload: unpinnedAppointments
                    });
                }
            }
        }).catch((error) => {
            console.log("-----------------",error)
        })
}

const sortAppointmentsForPatient = async (userId, dispatch, token, sortField, isAsc) => {
    var pageNum = 0;
    console.log("Sorting appointments for user:", userId, "Sort field:", sortField, "Is ascending:", isAsc)
    console.log("Token being used for sort:", token ? "Token exists" : "Token is null/undefined")
    if (!token) {
        console.error("No token provided for sortAppointmentsForPatient");
        return;
    }
    var fetchApptsForUser = PmsUrlConfig.BOS_FETCH_APPOINTMENTS_FOR_PATIENT_URL + userId + "/" + pageNum + "/" + sortField + "/" + isAsc
    setAuthToken(token)
    Axios.get(fetchApptsForUser)
        .then(response => response.data)
        .then(apptResponse => {
            var currentPageNum = apptResponse.PageNum
            var appointmentsForUser = apptResponse.Appointments
            if(appointmentsForUser === null) {
                console.log("No appointments found");
                dispatch({
                    type: 'setPinnedAppointments',
                    payload: null
                });
                dispatch({
                    type: 'setUnPinnedAppointments',
                    payload: null
                });
                dispatch({
                    type: 'setCurrentPageNumber',
                    payload: parseInt(currentPageNum)
                });
                dispatch({
                    type: 'setAppointmentsForUser',
                    payload: null
                });
                return;
            }
            dispatch({
                type: 'setAppointmentsForUser',
                payload: appointmentsForUser
            });
            // Save sorted appointments to localStorage for caching
            saveAppointmentsToStorage(appointmentsForUser);
            console.log("-----------------Sorted Appointments:",appointmentsForUser)
            dispatch({
                type: 'setCurrentPageNumber',
                payload: parseInt(currentPageNum)
            });
            
        }).catch((error) => {
            console.log("-----------------",error)
        })
}

const handleAcceptAppointment = async(appt, loggedInUser, patientId, service_location_id, service_loc_name, practiceId, practice, dispatch, serviceType, token) => {
    // Validate required parameters
    if (!appt || !appt.appointment_basic_details || !appt.appointment_basic_details._id) {
        console.error('ERROR: Invalid appointment data');
        alert('Invalid appointment data');
        return;
    }
    
    // Get synapse user groups from practice parameter
    console.log('=== DETAILED PRACTICE DEBUG ===');
    console.log('Practice parameter type:', typeof practice);
    console.log('Practice parameter value:', practice);
    console.log('Practice is null/undefined:', practice == null);
    console.log('Practice has synapse_practice_members_group_name:', practice?.hasOwnProperty('synapse_practice_members_group_name'));
    console.log('synapse_practice_members_group_name value:', practice?.synapse_practice_members_group_name);
    console.log('synapse_practice_members_group_name type:', typeof practice?.synapse_practice_members_group_name);
    
    const synapseUserGroups = practice?.synapse_practice_members_group_name ? [practice.synapse_practice_members_group_name] : [];
    
    console.log('Final synapseUserGroups:', synapseUserGroups);
    console.log('=== END DETAILED PRACTICE DEBUG ===');
    
    if (!loggedInUser || !loggedInUser._id) {
        console.error('ERROR: Invalid logged in user');
        alert('Invalid user data');
        return;
    }
    
    if (!service_location_id) {
        console.error('ERROR: Missing service location ID');
        alert('Missing service location');
        return;
    }
    
    if (!token) {
        console.error('ERROR: No authentication token');
        alert('No authentication token - please login again');
        return;
    }
    
    var selectedApptId = appt.appointment_basic_details._id;
    var appt_date = formatDateForRoomName(appt.appointment_basic_details.create_date_time);

    var roomName = appt.created_by_user.firstname + ' ' + appt.created_by_user.lastname+'-' + service_loc_name + '-' +serviceType+'-'+appt_date;

    var acceptAppointmentUrl = PmsUrlConfig.BOS_ACCEPT_APPOINTMENT_URL + selectedApptId;
    
    console.log('Accept appointment URL:', acceptAppointmentUrl);
    console.log('Request payload:', {
        service_location_id: service_location_id,
        appointment_id: selectedApptId,
        practice_id: practiceId,
        staff_user_id: loggedInUser._id,
        patient_user_id: patientId,
        last_updated_date_time: formatDate(new Date()),
        room_name: roomName,
        synapse_user_groups: synapseUserGroups
    });
    
    setAuthToken(token);
    
    try {
        const response = await Axios.post(acceptAppointmentUrl, {
            service_location_id: service_location_id,
            appointment_id: selectedApptId,
            practice_id: practiceId,
            staff_user_id: loggedInUser._id,
            patient_user_id: patientId,
            last_updated_date_time: formatDate(new Date()),
            room_name: roomName,
            synapse_user_groups: synapseUserGroups
        });
        
        if (response.status === 200) {
            console.log("*********RESPONSE:*********",response.data);
            appt.nearest_practices = response.data.nearest_practices;

            // Submit audit log for chat room creation
            console.log("🔍 === AUDIT SUBMISSION START - ROOM CREATION ===");
            console.log("🔍 Scenario: Chat room created during appointment acceptance");
            console.log("🔍 Appointment ID:", selectedApptId);
            console.log("🔍 Staff User ID:", loggedInUser._id);
            console.log("🔍 Username:", loggedInUser.username);
            console.log("🔍 Email:", loggedInUser.email);
            console.log("🔍 Room Name:", roomName);
            console.log("🔍 Associate (will be sent):", loggedInUser.username || loggedInUser.email);
            console.log("🔍 Timestamp (will be sent):", new Date().toISOString());

            try {
                const auditResult = await submitAppointmentAudit(
                    selectedApptId,
                    loggedInUser,
                    token
                );
                console.log("🔍 Audit submission result:", auditResult);
                if (auditResult.success) {
                    console.log("✅ Audit log submitted successfully for chat room creation");
                } else {
                    console.error("❌ Failed to submit audit log for room creation:", auditResult.error);
                }
            } catch (auditError) {
                console.error("❌ Error submitting audit log for room creation:", auditError);
                console.error("❌ Audit error details:", {
                    message: auditError.message,
                    stack: auditError.stack,
                    name: auditError.name
                });
            }
            console.log("🔍 === AUDIT SUBMISSION END - ROOM CREATION ===");

            // Return the updated appointment with synapse_room_id
            return appt;
        }
    } catch (error) {
        console.error('Error accepting appointment:', error);
        if (error.response?.data?.error_code?.description) {
            dispatch({
                type: 'apptSubmitError',
                payload: error.response.data.error_code.description
            });
        }
    }
};

const viewChat = async (selectedAppointment, loggedInUser, nearest_practice, dispatch) => {
    
    console.log('=== viewChat Function Debug ===');
    console.log('Selected Appointment:', selectedAppointment);
    console.log('Nearest Practice:', nearest_practice);
    console.log('Synapse Room ID:', nearest_practice.synapse_room_id);
    
    dispatch({
        type: 'setSynapseRoomID',
        payload: nearest_practice.synapse_room_id
    });
    dispatch({
        type: 'showChat',
    });
    
    console.log('Dispatched showChat and setSynapseRoomID actions');

}

const checkForNewAppointments = (serviceIds, dispatch, token) => {
    console.log("=== checkForNewAppointments CALLED ===");
    console.log("Service IDs:", serviceIds);
    console.log("Current time:", new Date().toISOString());
    
    var requestObj = []
    serviceIds.forEach(function(servId, index) {
        requestObj.push({"service_id":servId, "count":0})
    })
    
    var getAppointmentCountUrl = PmsUrlConfig.BOS_GET_APPOINTMENT_COUNT_URL;
    console.log("Making POST request to:", getAppointmentCountUrl);
    
    if(requestObj && requestObj.length >0){
        setAuthToken(token);
        Axios.post(getAppointmentCountUrl, requestObj
            ).then((response) => {
                console.log("checkForNewAppointments response status:", response.status);
                if (response.status === 200) {
                    dispatch({
                        type: 'setAppointmentCountForService',
                        payload: response.data
                    })
                }
                else if (response.status === 400 ) {
                    console.log(response.data.error_code.description)
                }
            }).catch((error) => {
            console.log("error-------->",error)
            console.log(error.response.data.error_code.description)
        })
    }
    
  }
  const fetchAppointmentDetails = async (apptId, dispatch, token) => {

    var fetchMsgForUser = PmsUrlConfig.BOS_FETCH_APPOINTMENT_BY_ID_FOR_PATIENT_URL + apptId 
    setAuthToken(token);
    Axios.get(fetchMsgForUser)
        .then(response => response.data)
        .then(apptResponse => {
            dispatch({
                type: 'selectAppointment',
                payload: apptResponse
              });
            
        }).catch((error) => {
            dispatch({
                type: 'selectAppointment',
                payload: null
              });
        })
}
const getAppointmentsForService = (selectedServiceId, dispatch, token) => {
    console.log("=== getAppointmentsForService CALLED ===");
    console.log("Selected Service ID:", selectedServiceId);
    console.log("Current time:", new Date().toISOString());
    
    var fetchApptsForService = PmsUrlConfig.BOS_FETCH_APPOINTMENT_FOR_SERVICE_URL + selectedServiceId
    console.log("=== getAppointmentsForService START ===");
    console.log("fetchApptsForService URL:", fetchApptsForService);
    console.log("token exists:", !!token);
    
    setAuthToken(token);
    console.log("Making GET request to:", fetchApptsForService);
    Axios.get(fetchApptsForService)
        .then(response => {
            
            console.log("=== getAppointmentsForService RESPONSE RECEIVED ===");
            console.log("Response status:", response.status);
            console.log("Response data:", response.data);
            
            return response.data;
        })
        .then(apptsForService => {
            console.log("=== APPOINTMENTS RESPONSE DEBUG ===");
            console.log("🔍 apptsForService being dispatched:", apptsForService);
            console.log("Number of appointments:", apptsForService ? apptsForService.length : 0);
            if (apptsForService && apptsForService.length > 0) {
                apptsForService.forEach((appt, index) => {
                    console.log(`Appointment ${index + 1}:`, {
                        _id: appt._id,
                        status: appt.appointment_basic_details?.status,
                        create_date: appt.create_date_time,
                        nearest_practices: appt.nearest_practices?.length || 0
                    });
                });
            }
            console.log("=== END APPOINTMENTS DEBUG ===");
               
            dispatch({
                type: 'setAppointmentsForService',
                payload: apptsForService
              });
            if (apptsForService != null ){
                var pinnedAppointments = apptsForService.filter(item => item.nearest_practices[0].staff_pinned);
                if(pinnedAppointments != null){
                    dispatch({
                        type: 'setPinnedAppointments',
                        payload: pinnedAppointments
                      });
                }
                var unpinnedAppointments = apptsForService.filter(item => !item.nearest_practices[0].staff_pinned);
                if(unpinnedAppointments != null){
                    dispatch({
                        type: 'setUnPinnedAppointments',
                        payload: unpinnedAppointments
                      });
                }
            }else {
                //No appointments found for service
                dispatch({
                    type: 'setPinnedAppointments',
                    payload: null
                  });
                  dispatch({
                    type: 'setUnPinnedAppointments',
                    payload: null
                  });

            }
            console.log("🔍 === getAppointmentsForService END ===");
                
        }).catch((error) => {
            console.log("❌ Error in getAppointmentsForService:", error)
        })
}

const getAppointmentsByFilter = (selectedServiceId, dispatch, token, filters, systemConstants = null) => {
    const filterUrl = PmsUrlConfig.BOS_FETCH_APPOINTMENTS_BY_FILTER_URL;
    
    // Build the filter criteria object
    const filterCriteria = {
        service_id: selectedServiceId,
        sort_field: "appointment_basic_details.create_date_time",
        is_ascending: false,
        page: {
            page_number: 1,
            page_size: 100
        }
    };

    // Handle combined filters (multiple filter types applied together)
    if (filters && filters.type === 'combined' && filters.value) {
        
        // Check if this is a neutral filter (empty object) - equivalent to no filtering
        if (Object.keys(filters.value).length === 0) {
            // Backend requires at least one filter criteria, so add default date range (last 30 days)
            const endDate = new Date();
            const startDate = new Date();
            startDate.setDate(endDate.getDate() - 30); // 30 days ago
            
            filterCriteria.request_date_range = {
                start: startDate.toISOString().split('T')[0], // Format: YYYY-MM-DD
                end: endDate.toISOString().split('T')[0]
            };
        } else {
        
        // Add date range filter if present in combined filter
        if (filters.value.date && filters.value.date.value && filters.value.date.value.start && filters.value.date.value.end) {
            filterCriteria.request_date_range = {
                start: filters.value.date.value.start,
                end: filters.value.date.value.end
            };
        }
        
        // Add status filter if present in combined filter
        if (filters.value.status && filters.value.status.value && Array.isArray(filters.value.status.value) && filters.value.status.value.length > 0) {
            // Map status names to backend integer values using system constants from Redux store
            const statusMap = {};
            
            // Use system constants from Redux store if available
            if (systemConstants?.statuses) {
                // Create a map from status name to status integer
                Object.entries(systemConstants.statuses).forEach(([key, value]) => {
                    statusMap[value] = parseInt(key);
                });
                
                // Map the selected status names to integers
                const mappedStatuses = filters.value.status.value
                    .map(statusName => statusMap[statusName])
                    .filter(status => status !== undefined); // Filter out any undefined mappings
                
                if (mappedStatuses.length > 0) {
                    filterCriteria.appointment_status = mappedStatuses;
                }
            }
        }
        
        // Add associate filter if present in combined filter
        if (filters.value.associate && filters.value.associate.value && filters.value.associate.value.trim()) {
            filterCriteria.associate_id = filters.value.associate.value.trim();
        }
        }
    } else {
        // Handle individual filter types (legacy support)
        
        // Add date range filter if provided (legacy)
        if (filters && filters.type === 'date' && filters.value && filters.value.start && filters.value.end) {
            filterCriteria.request_date_range = {
                start: filters.value.start,
                end: filters.value.end
            };
        }

        // Add status filter if provided (legacy)
        if (filters && filters.type === 'status' && filters.value && Array.isArray(filters.value) && filters.value.length > 0) {
            // Map status names to backend integer values using system constants from Redux store
            const statusMap = {};
            
            // Use system constants from Redux store if available
            if (systemConstants?.statuses) {
                // Map status names from backend system constants to their integer values
                // Note: systemConstants.statuses has keys as integers and values as status names
                Object.entries(systemConstants.statuses).forEach(([statusKey, statusName]) => {
                    statusMap[statusName] = parseInt(statusKey); // Convert key to integer
                });
            } else {
                // Fallback values when system constants not loaded
                statusMap['New'] = 1;
                statusMap['Active'] = 2;
                statusMap['Suspended'] = 3;
                statusMap['Deleted'] = 4;
                statusMap['Completed'] = 5;
                statusMap['Declined'] = 6;
            }
            
            // Frontend fallback names for backward compatibility
            statusMap['Pending'] = 1;
            statusMap['Accepted'] = 2;
            statusMap['Declined'] = 6;
            statusMap['Completed'] = 5;
            
            // Convert all selected statuses to integer values
            const statusValues = [];
            filters.value.forEach((status, index) => {
                const statusValue = statusMap[status.toUpperCase()] || statusMap[status];
                if (statusValue) {
                    statusValues.push(statusValue);
                }
            });
            
            if (statusValues.length > 0) {
                // Send multiple statuses to backend
                filterCriteria.appointment_statuses = statusValues;
            }
        }

        // Add associate filter if provided (legacy)
        if (filters && filters.type === 'associate' && filters.value && filters.value.trim()) {
            // Note: Backend doesn't directly support associate name filtering in this endpoint
            // This would need to be implemented on the backend side
        }
    }

    setAuthToken(token);
    Axios.post(filterUrl, filterCriteria)
        .then(response => {
            if (response.data && response.data.appointments) {
                const appointments = response.data.appointments;
                
                dispatch({
                    type: 'setAppointmentsForService',
                    payload: appointments
                });
                
                dispatch({
                    type: 'setAppointmentsPagination',
                    payload: response.data.page || { total_count: appointments.length }
                });
            } else {
                console.log("⚠️ No appointments data in response");
                dispatch({
                    type: 'setAppointmentsForService',
                    payload: []
                });
            }
            
            console.log("🔍 === getAppointmentsByFilter END ===");
        })
        .catch((error) => {
            console.log("❌ Error in getAppointmentsByFilter:", error);
            // Fallback to regular endpoint if filter fails
            console.log("🔄 Falling back to regular appointment fetch");
            getAppointmentsForService(selectedServiceId, dispatch, token);
        });
}

const sortAppointmentsForService = (selectedServiceId, dispatch, token, sortField, isAscending) => {
    var fetchApptsForService = PmsUrlConfig.BOS_FETCH_APPOINTMENT_FOR_SERVICE_URL + selectedServiceId + "/" +sortField +"/"+isAscending;
        setAuthToken(token);
        Axios.get(fetchApptsForService)
            .then(response => response.data)
            .then(apptsForService => {
               
                dispatch({
                    type: 'setAppointmentsForService',
                    payload: apptsForService
                  });
                if (apptsForService != null ){
                    var pinnedAppointments = apptsForService.filter(item => item.nearest_practices[0].staff_pinned);
                    if(pinnedAppointments != null){
                        dispatch({
                            type: 'setPinnedAppointments',
                            payload: pinnedAppointments
                          });
                    }
                    var unpinnedAppointments = apptsForService.filter(item => !item.nearest_practices[0].staff_pinned);
                    if(unpinnedAppointments != null){
                        dispatch({
                            type: 'setUnPinnedAppointments',
                            payload: unpinnedAppointments
                          });
                    }
                }else {
                    //No appointments found for service
                    dispatch({
                        type: 'setPinnedAppointments',
                        payload: null
                      });
                      dispatch({
                        type: 'setUnPinnedAppointments',
                        payload: null
                      });

                }
                
            }).catch((error) => {
                console.log("-----------------",error)
            })
}
// eslint-disable-next-line
const MarkRead = (appt, loggedInUser, synapseRoomId, eventId) => {

    var sendTextUrl = PmsUrlConfig.BOS_MARK_READ_URL + appt.appointment_basic_details._id
    Axios.post(sendTextUrl, 
        {
            appointment_id: appt.appointment_basic_details._id,
            sender_id: loggedInUser.synapse_user_id,
            access_token: loggedInUser.access_token,
            event_id: eventId,
            room_id: synapseRoomId
        }).then((response) => {
            if (response.status === 200) {
                console.log("Read Receipt sent successfully!!!")
            }
            else if (response.status === 400 ) {
                console.log(response.data.error_code.description)
            }
        }).catch((error) => {
            console.log("error-------->",error)
            console.log(error.response.data.error_code.description)
        })

}

const handleDeleteAppointment = async(appt, loggedInUser, dispatch, token) => {
    console.log("Selected Appointment:",appt)
    var selectedApptId = "";
    if(appt && appt.appointment_basic_details){
        selectedApptId = appt.appointment_basic_details._id;
    }
    else {
        selectedApptId = appt._id;
    }
    var deleteAppointmentUrl = PmsUrlConfig.BOS_DELETE_APPOINTMENT_URL + selectedApptId;
   
    setAuthToken(token);
    Axios.delete(deleteAppointmentUrl ).then((response) => {
            if (response.status === 200) {
                console.log("*********RESPONSE:*********",response.data)
                console.log("Appointment Deleted");
                return true;
            }
            else if (response.status === 400 ) {
                console.log(response.data.error_code.description)
                dispatch({
                    type: 'apptSubmitError',
                    payload: response.data.error_code.description
                })
                return false;
            }
        }).catch((error) => {
            console.log("error-------->",error)
            console.log(error.response.data.error_code.description)
            dispatch({
                type: 'apptSubmitError',
                payload: error.response.data.error_code.description
            })
            return false;
        })
};


function capitalize(s)
{
    return s[0].toUpperCase() + s.slice(1);
}
var syncChatVar;
function syncMessages(synapseRoomId, matrixClient, dispatch, loggedInUser = null, selectedAppointment = null)
{
    if (!synapseRoomId || !matrixClient) {
        return;
    }
    syncChatVar = setTimeout(async () => {
        try {
            await getRoomInitialSync(synapseRoomId, matrixClient, dispatch);
        } catch (error) {
            // Check if it's an access error and try to join if there's an invite
            if (error.httpStatus === 403 || error.errcode === 'M_FORBIDDEN' || error.message?.includes('not in room')) {
                if (!loggedInUser) {
                    dispatch({
                        type: 'setErrorMsg',
                        payload: 'No access'
                    });
                    dispatch({
                        type: 'hideChat',
                    });
                    setTimeout(() => {
                        dispatch({ type: 'setErrorMsg', payload: null });
                    }, 3000);
                    return;
                }
                
                try {
                    // Get appointment ID for audit logging
                    const appointmentId = selectedAppointment?._id || selectedAppointment?.appointment_basic_details?._id;
                    
                    // Import verifyAndJoinStaffUser dynamically to avoid circular dependency
                    const { verifyAndJoinStaffUser } = require('../matrix/matrixFuntions');
                    
                    // Attempt to verify and join the room
                    const joinResult = await verifyAndJoinStaffUser(
                        loggedInUser, 
                        matrixClient, 
                        synapseRoomId, 
                        appointmentId, 
                        dispatch
                    );
                    
                    if (joinResult) {
                        // Step 3: Sync room messages again after successful join
                        try {
                            await getRoomInitialSync(synapseRoomId, matrixClient, dispatch);
                        } catch (syncError) {
                            // Even if sync fails, user is in the room, so don't show "No access"
                            dispatch({ type: 'setSynapseEvents', payload: [] });
                        }
                    } else {
                        // Step 4: No access and no invite - show error message
                        dispatch({
                            type: 'setErrorMsg',
                            payload: 'No access'
                        });
                        // Close chat modal
                        dispatch({
                            type: 'hideChat',
                        });
                        // Clear error message after 3 seconds
                        setTimeout(() => {
                            dispatch({ type: 'setErrorMsg', payload: null });
                        }, 3000);
                    }
                } catch (joinError) {
                    // Step 4: Join failed - show error message
                    dispatch({
                        type: 'setErrorMsg',
                        payload: 'No access'
                    });
                    // Close chat modal
                    dispatch({
                        type: 'hideChat',
                    });
                    // Clear error message after 3 seconds
                    setTimeout(() => {
                        dispatch({ type: 'setErrorMsg', payload: null });
                    }, 3000);
                }
            }
        }
    }, 5000);
} 

function stopSync(){
    if (syncChatVar) {
        clearTimeout(syncChatVar);
        syncChatVar = null;
    }
}

const getLastAssociateFromAudit = (auditData) => {
    if (!auditData || !auditData.data || !Array.isArray(auditData.data)) {
        return null;
    }
    
    // Sort audit entries by start_date_time in descending order to get the most recent
    const sortedAuditEntries = auditData.data.sort((a, b) => {
        const dateA = new Date(a.start_date_time);
        const dateB = new Date(b.start_date_time);
        return dateB - dateA; // Most recent first
    });
    
    // Get the most recent entry
    const mostRecentEntry = sortedAuditEntries[0];
    
    if (mostRecentEntry && mostRecentEntry.associate) {
        return mostRecentEntry.associate;
    }
    
    return null;
};


const submitAppointmentAudit = async (appointmentId, associate, jwt_token) => {
    console.log("🔍 === submitAppointmentAudit START ===");
    console.log("🔍 appointmentId:", appointmentId);
    console.log("🔍 associate:", associate);
    console.log("🔍 token exists:", !!jwt_token);
    console.log("🔍 token type:", typeof jwt_token);
    console.log("🔍 token length:", jwt_token ? jwt_token.length : "null");
    console.log("🔍 token starts with Bearer:", jwt_token ? jwt_token.startsWith("Bearer ") : "null");
    
    // Safety check - don't create audit if associate is empty
    if (!associate == null) {
        console.log("🔍 SKIPPING audit submission - associate is empty");
        return { success: false, message: "Associate is empty" };
    }
    
    const auditData = {
        associate_id: associate._id,
        start_date_time: new Date().toISOString()
    };
    
    console.log("🔍 auditData:", auditData);
    
    const auditUrl = PmsUrlConfig.BOS_SUBMIT_APPOINTMENT_AUDIT_URL + appointmentId + '/audit/submit';
    console.log("🔍 Full audit URL:", auditUrl);
    
    setAuthToken(jwt_token);
    
    // Check what headers are being set
    console.log("🔍 Setting auth token, checking headers...");
    console.log("🔍 Axios defaults before request:", JSON.stringify(Axios.defaults.headers));
    
    // Force a small delay to ensure headers are set
    await new Promise(resolve => setTimeout(resolve, 100));
    
    console.log("🔍 Axios defaults after setAuthToken:", JSON.stringify(Axios.defaults.headers));
    console.log("🔍 Common headers:", JSON.stringify(Axios.defaults.headers.common));
    console.log("🔍 Authorization header:", Axios.defaults.headers.common["Authorization"]);
    
    try {
        console.log("🔍 Sending POST request to audit endpoint...");
        const response = await Axios.post(auditUrl, auditData);
        console.log("🔍 Audit response status:", response.status);
        console.log("🔍 Audit response data:", response.data);
        console.log("🔍 Audit response headers:", response.headers);
        
        if (response.status === 200) {
            console.log("✅ Appointment audit submitted successfully:", response.data);
            return { success: true, data: response.data };
        } else {
            console.error("❌ Failed to submit appointment audit:", response.data);
            return { success: false, error: response.data };
        }
    } catch (error) {
        console.error("❌ === AUDIT SUBMISSION ERROR ===");
        console.error("❌ Error message:", error.message);
        console.error("❌ Error stack:", error.stack);
        console.error("❌ Error response:", error.response);
        console.error("❌ Error status:", error.response?.status);
        console.error("❌ Error data:", error.response?.data);
        console.error("❌ Error headers:", error.response?.headers);
        console.error("❌ Request config:", error.config);
        console.error("❌ === END AUDIT SUBMISSION ERROR ===");
        return { success: false, error: error.message };
    }
};

export {
    handlePatientPinAppointment,
    togglePinned,
    formatDateForUI,
    formatDate,
    formatDateForMessages,
    getServiceTypeString,
    fetchUserAppointments,
    handleArchiveAppointmentForPatient,
    handleAcceptAppointment,
    handleDeleteAppointment,
    viewChat,
    checkForNewAppointments,
    fetchAppointmentDetails,
    sortAppointmentsForService,
    sortAppointmentsForPatient,
    getAppointmentsForService,
    getAppointmentsByFilter,
    capitalize,
    syncMessages,
    stopSync,
    submitAppointmentAudit,
    getLastAssociateFromAudit
}